<div class="modal-signup modal-content padding-left-10px border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">
        <div class="row">
          <div class="col-md-10 padding-left-0px">
            <label class="margin-bottom-0px color-Assign font-weight-bold">Return Material ({{MaterialSpecName}})</label>
          </div>
          <div class="col-md-2 float-right">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Entry Date :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{EntryDate | date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">HsnCode :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{HsnCode}}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Supplier :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{SupplierShortName}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Batch :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{BatchNo}}</label>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Expiry Date :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{ExpiryDate | date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Tax(%) :</label>
              </div>
              <div class="col-md-8 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{TaxPercent}}</label>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Batch Quantity :</label>
              </div>
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{BatchQuantity}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Available Quantity :</label>
              </div>
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{AvailableQuantity}}</label>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Purchase Price :</label>
              </div>
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{PurchaseUnitPrice}}</label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Selling Price :</label>
              </div>
              <div class="col-md-6 padding-right-0px padding-left-0px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{SellingPrice}}</label>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">
        <div class="">
            <form class="form" novalidate="" (ngSubmit)="SaveMaterial()" #f="ngForm">

              <div class="card">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">

                          <div class="row" *canUserAccess="['HL_ER_12']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Return Quantity</label>
                                </div>
                                <div class="col-md-5">
                                  <input type="text" class="form-control" placeholder="Return Quantity"
                                         id="ReturnQuantity"
                                         [(ngModel)]="ReturnQuantity"
                                         name="ReturnQuantity" #RetnQty="ngModel"
                                         maxlength="6" pattern="[0-9]{6}" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!RetnQty.valid && (RetnQty.dirty || RetnQty.touched) && RetnQty.errors.required )">
                                    (Field cannot be left blank)
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row" *canUserAccess="['HL_ER_15']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Reason</label>
                                </div>
                                <div class="col-md-5">
                                  <CodeTypeValue CodeType="RETREM" id="Reason"
                                                 [(ngModel)]="Reason" SelectedValue=""
                                                 name="Reason">
                                  </CodeTypeValue>
                                </div>

                              </div>

                            </div>
                          </div>

                          <div class="row" *canUserAccess="['HL_ER_12']">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-4 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Remarks</label>
                                </div>
                                <div class="col-md-8">
                                  <textarea class="form-control3 size-2 width-inherit" rows="3" placeholder="Remarks"
                                            name="Remarks"
                                            [(ngModel)]="Remarks" minlength="1" maxlength="1024"
                                            Remarks="ngModel"></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">OK</button>                           
                  <button type="button" class="btn btn-secondary btn-raised margin-right-15px float-right button-Schedule actions-btn-prime actions-btn-prime3 font-size-13px" (click)="activeModal.close('Close click')">Cancel</button>
                </div>
              </div>
            </form>        
        </div>
      </div>
    </div>
  </div>
</div>
